<div class="orders py-4">
  <div class="row">
    <jni-add-edit-header
      [billerCollectorHeader]="userHeaderInfo"
      (smallLoaderEvent)="getLoaderStatus($event)"
      (refreshGrid)="reloadUserLists()"></jni-add-edit-header>
  </div>
  <div class="row">
    <div class="col-6">
      <jni-biller-listing
        [BillerListing]="billerList"
        (updateUser)="updateBiller($event)"></jni-biller-listing>
    </div>
    <div class="col-6">
      <jni-collector-listing
        [CollectorListing]="collectorList"
        (updateUser)="updateCollector($event)"></jni-collector-listing>
    </div>
  </div>
</div>
